module.exports = __webpack_public_path__ + "img/451-1af0db.png";